/* サパれる！ 商品ページ見積もり計算（箇所ごと色数 / plates=Σ各箇所の色数） */
(function() {
  'use strict';

  function yen(n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); }

  function calcEstimate(input) {
    var P = window.PRICING;
    var qty = Math.max(0, input.qty|0);
    var positions = Math.max(1, input.positions|0);
    // plates（総版数）= 各箇所の色数の合計。未指定なら従来の colors×positions にフォールバック。
    var plates = (input.plates != null) ? Math.max(1, input.plates|0) : Math.max(1, input.colors|0) * positions;
    var wearUnit = input.wearPrice|0;
    var isAdditional = !!input.isAdditional;

    if (qty === 0) {
      return { qty:0, tier:P.tiers[0], wear:0, plate:0, print:0, upExtra:0,
        fold:0, name:0, shipping:0, subtotal:0, total:0, unit:0, plates:plates,
        silkPlates:plates, locMethods:null };
    }

    var tier = P.findTier(qty);

    // wearTotal が渡されればサイズ別実価格の合計を優先（カート実額と一致）
    var wear = (input.wearTotal != null) ? input.wearTotal : wearUnit * qty;
    // シルク vs DTF を「箇所ごと」に自動比較し、最安の組み合わせを採用（併用対応）。
    // locColors が無い旧呼び出しは従来の全体判定にフォールバック。
    var quote;
    if (P.quotePrintByLocation && input.locColors && input.locColors.length) {
      quote = P.quotePrintByLocation({
        qty: qty, locColors: input.locColors,
        isAdditional: isAdditional,
        plateMult: input.plateMultiplier || 1
      });
    } else {
      quote = P.quotePrint({
        qty: qty, plates: plates, positions: positions,
        isAdditional: isAdditional, fullColor: !!input.fullColor,
        plateMult: input.plateMultiplier || 1
      });
    }
    var printTotal = quote.printTotal;
    var plateTotal = quote.plateTotal;
    var fold = input.fold ? P.foldPerPiece * qty : 0;
    var nameCount = Math.max(0, parseInt(input.nameNum, 10) || 0);
    var name = nameCount * P.namePerPiece;
    var subtotal = wear + plateTotal + printTotal + fold + name;
    var shippingBase = wear + printTotal + fold + name;
    var shipping = shippingBase >= P.shippingFree ? 0 : P.shippingFee;
    var total = subtotal + shipping;
    var unit = qty > 0 ? total / qty : 0;

    return { qty:qty, tier:tier, plates:plates,
      silkPlates: (quote.silkPlates != null) ? quote.silkPlates : plates,
      locMethods: quote.locMethods || null,
      wear:wear, plate:plateTotal, print:printTotal,
      method:quote.method, methodLabel:quote.label, dtfUnit:quote.dtfUnit,
      fold:fold, name:name, shipping:shipping, subtotal:subtotal, total:total, unit:unit };
  }

  function initEstimator(root) {
    if (!root || root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';
    var wearPrice = parseInt(root.dataset.wearPrice || '0', 10);

    var $ = function(s) { return root.querySelector(s); };
    var $$ = function(s) { return root.querySelectorAll(s); };
    var lastRes = null;     // 直近の見積もり結果（カート追加時の料金ライン生成に使用）
    var lastInput = null;   // 直近の入力内容
    var MAX_LOC = 12;       // プリント箇所の上限

    function getSizeQty() {
      var total = 0;
      $$('.est-size input').forEach(function(el) {
        total += Math.max(0, parseInt(el.value || '0', 10));
      });
      return total;
    }

    /* ===== プリント箇所ごとの色数 ===== */
    function getLocationEls() {
      return Array.prototype.slice.call($$('.est-loc-list .est-loc'));
    }
    function getLocationColors() {
      return getLocationEls().map(function(loc) {
        var el = loc.querySelector('input[type="radio"]:checked') || loc.querySelector('input[type="radio"]');
        return Math.max(1, parseInt((el && el.value) || '1', 10));
      });
    }
    function getPlates() {
      var sum = getLocationColors().reduce(function(a, b) { return a + b; }, 0);
      return Math.max(1, sum);
    }
    // 9色以上を選んだ箇所があれば「フルカラー」= DTF扱い
    function getFullColor() {
      return getLocationColors().some(function(c) { return c >= 9; });
    }
    function getPositions() {
      return Math.max(1, getLocationEls().length);
    }
    function getLocationLabels(locMethods) {
      // locMethods（箇所ごとの手法判定結果）があれば「（シルク）/（DTF）」を付記
      return getLocationColors().map(function(c, i) {
        var base = (i + 1) + '箇所目' + c + '色';
        var m = locMethods && locMethods[i];
        if (m) base += m.method === 'dtf' ? '（DTF）' : '（シルク）';
        return base;
      });
    }

    function getMode() {
      var el = $('.est-mode input:checked') || $('.est-mode input');
      return (el && el.value) === 'additional';
    }

    function getNameCount() {
      var el = $('.est-name-count');
      return Math.max(0, parseInt((el && el.value) || '0', 10));
    }

    /* variant マップ（{id,size,color,price}）を取得。セクション側に埋め込まれている */
    var _variantMapCache = null;
    function getVariantMap() {
      if (_variantMapCache) return _variantMapCache;
      var section = (root.closest && root.closest('.estimator-section')) || root.parentElement || document;
      var mapEl = root.querySelector('[data-est-variant-map]') || section.querySelector('[data-est-variant-map]');
      if (!mapEl) return (_variantMapCache = []);
      try { _variantMapCache = JSON.parse(mapEl.textContent) || []; } catch(_) { _variantMapCache = []; }
      return _variantMapCache;
    }
    function getSelectedColor() {
      var sel = document.querySelector('.pdetail__swatch.is-selected');
      if (sel) return sel.dataset.optionValue;
      var estEl = (root.matches && root.matches('.estimator')) ? root : root.querySelector('.estimator');
      return (estEl && estEl.dataset.defaultColor) || null;
    }
    /* サイズ別の枚数 × その variant の実価格 を合計（カート実額と一致させる） */
    function getWearTotal() {
      var variants = getVariantMap();
      if (!variants.length) return null; // マップ無ければ従来の固定単価計算にフォールバック
      var color = getSelectedColor();
      var total = 0;
      $$('.est-size').forEach(function(cell){
        var label = cell.querySelector('label');
        var input = cell.querySelector('input[type="number"]');
        if (!label || !input) return;
        var sizeName = (label.textContent || '').trim();
        var q = Math.max(0, parseInt(input.value || '0', 10));
        if (q <= 0) return;
        var v = variants.find(function(x){
          var sm = !x.size || x.size === sizeName;
          var cm = !color || !x.color || x.color === color;
          return sm && cm;
        });
        var price = v && typeof v.price === 'number' ? v.price : wearPrice;
        total += price * q;
      });
      return total;
    }

    function update() {
      var qty = getSizeQty();
      var nameCount = getNameCount();
      var plates = getPlates();
      var positions = getPositions();
      var estInput = {
        qty: qty,
        plates: plates,
        positions: positions,
        locColors: getLocationColors(),
        fold: $('.est-fold') && $('.est-fold').checked,
        nameNum: nameCount,
        isAdditional: getMode(),
        fullColor: getFullColor(),
        wearPrice: wearPrice,
        wearTotal: getWearTotal()
      };
      var res = calcEstimate(estInput);
      lastRes = res;
      lastInput = estInput;

      setText('.est-out-qty', qty + '枚');
      setText('.est-out-tier', res.qty ? (res.tier.min + '〜' + res.tier.max + '枚') : '—');
      setText('.est-out-wear', yen(res.wear));
      setText('.est-out-plate', yen(res.plate));
      setText('.est-out-print', yen(res.print));
      setText('.est-out-fold', res.fold ? yen(res.fold) : '—');
      setText('.est-out-name', res.name ? yen(res.name) : '—');
      setText('.est-out-ship', res.shipping === 0 ? '無料' : yen(res.shipping));
      setText('.est-out-total', yen(res.total));
      setText('.est-out-unit', qty > 0 ? yen(res.unit) : '¥0');
      // 版数はシルク箇所のみカウント（DTF箇所は版なし）
      setText('.est-out-plates', res.silkPlates + '版');
      setText('.est-loc-count', positions);
      setText('.est-plate-count', res.silkPlates);
      // プリント手法（DTF or シルク＋DTF併用が最安の時のみ表示）
      var methodEl = $('[data-est-method]');
      if (methodEl) {
        if (res.qty > 0 && res.method === 'dtf') {
          methodEl.textContent = 'フルカラーDTFプリントが最安です';
          methodEl.hidden = false;
        } else if (res.qty > 0 && res.method === 'mix') {
          methodEl.textContent = 'シルク＋DTFプリントの併用が最安です';
          methodEl.hidden = false;
        } else {
          methodEl.hidden = true;
        }
      }

      updateBar(qty);
      updateSuggest(qty);

      var bar = document.getElementById('est-sticky-bar');
      if (bar) {
        bar.querySelector('[data-sticky-total]').textContent = qty > 0 ? yen(res.total) : '概算';
        bar.querySelector('[data-sticky-unit]').textContent = qty > 0 ? ('1枚 ' + yen(res.unit)) : '枚数を入力してください';
        if (root._userInteracted && qty > 0) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }

      var locLabels = getLocationLabels(res.locMethods);
      var payload = {
        qty: qty, plates: plates, positions: positions,
        fold: $('.est-fold') && $('.est-fold').checked ? 1 : 0,
        name: nameCount,
        mode: getMode() ? 'additional' : 'first',
        total: Math.round(res.total), unit: Math.round(res.unit),
        product: root.dataset.productTitle || ''
      };
      var q = Object.keys(payload).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k]);
      }).join('&');
      $$('[data-est-forward]').forEach(function(a) {
        var base = a.dataset.estForward;
        a.href = base + (base.indexOf('?') > -1 ? '&' : '?') + q;
      });
      var lineBtn = $('[data-est-line-msg]');
      if (lineBtn) {
        var msg = '【見積もり相談】\n商品: ' + (root.dataset.productTitle || '-') +
          '\n枚数: ' + qty + '枚（' + (getMode() ? '追加注文' : '初回') + '）' +
          '\nプリント箇所: ' + positions + '箇所（' + locLabels.join('・') + '） 計' + res.silkPlates + '版' +
          (res.method === 'mix' ? '\nプリント手法: シルク＋DTF併用' : (res.method === 'dtf' ? '\nプリント手法: DTFプリント' : '')) +
          '\nオプション: ' + (payload.fold ? 'たたみ袋入れ ' : '') + (nameCount > 0 ? ('背番号/名前 ' + nameCount + '箇所') : '') +
          '\n概算合計: ' + yen(res.total) + '（1枚 ' + yen(res.unit) + '）';
        lineBtn.dataset.estLineMsg = msg;
      }
    }

    function setText(sel, txt) {
      var el = $(sel);
      if (el) el.textContent = txt;
    }

    function updateBar(qty) {
      var bar = $('.est-range-bar');
      if (!bar) return;
      var max = 500;
      var pct = Math.min(100, (Math.min(qty, max) / max) * 100);
      var fill = bar.querySelector('.est-range-fill');
      if (fill) fill.style.width = pct + '%';
      $$('.est-range-mark').forEach(function(m) {
        var mm = parseInt(m.dataset.min, 10);
        m.classList.toggle('is-active', qty >= mm);
      });
    }

    function updateSuggest(qty) {
      var el = $('.est-suggest');
      if (!el) return;
      var P = window.PRICING;
      for (var i=0; i<P.tiers.length; i++) {
        var t = P.tiers[i];
        if (qty < t.min) {
          var need = t.min - qty;
          el.innerHTML = 'あと <strong>' + need + '枚</strong> で単価が <strong>' + t.min + '〜' + t.max + '枚レンジ</strong> に。1枚あたりがお得に!';
          el.classList.add('is-visible');
          return;
        }
      }
      el.classList.remove('is-visible');
    }

    function refreshActiveSizes() {
      $$('.est-size').forEach(function(cell) {
        var inp = cell.querySelector('input[type="number"]');
        var v = parseInt((inp && inp.value) || '0', 10);
        cell.classList.toggle('is-active', v > 0);
      });
    }

    // ユーザー操作検知（input / change / click のいずれかでフラグ立てる）
    function markInteracted(){ root._userInteracted = true; }
    root.addEventListener('input', function() { markInteracted(); refreshActiveSizes(); update(); });
    root.addEventListener('change', function(){ markInteracted(); update(); });
    root.addEventListener('click', function(e){
      if (e.target.closest('.est-stepper__btn, .est-tabs label, .est-chips label, .est-check, .est-name-row, .est-loc-add, .est-loc__remove')) {
        markInteracted();
      }
    });
    root.addEventListener('focusin', function(e) {
      if (e.target.matches('.est-size input[type="number"]')) e.target.select();
    });

    /* ===== プリント箇所ごとの色数：追加・削除・採番 ===== */
    function renumberLocations() {
      var locs = getLocationEls();
      locs.forEach(function(loc, i) {
        var n = i + 1;
        var nameEl = loc.querySelector('[data-loc-name]');
        if (nameEl) nameEl.textContent = n + '箇所目';
        // ラジオの name を箇所ごとにユニーク化（同一箇所内で単一選択にする）
        loc.querySelectorAll('input[type="radio"]').forEach(function(r) {
          r.name = 'est-loc-colors-' + n;
        });
        loc.setAttribute('data-only', locs.length === 1 ? '1' : '0');
      });
      var addBtn = $('[data-loc-add]');
      if (addBtn) addBtn.disabled = locs.length >= MAX_LOC;
    }
    function addLocation() {
      var list = $('[data-loc-list]');
      var locs = getLocationEls();
      if (!list || locs.length >= MAX_LOC) return;
      var clone = locs[0].cloneNode(true);
      // 複製直後は1箇所目とradioのnameが同じ。そのままappendすると同一nameグループ制約で
      // 1箇所目のチェックが外れる（=選択リセットバグ）ため、先にnameをユニーク化してから追加する
      clone.querySelectorAll('input[type="radio"]').forEach(function(r, idx) {
        r.name = 'est-loc-colors-' + (locs.length + 1);
        r.checked = (idx === 0); // 新しい箇所は1色スタート
      });
      list.appendChild(clone);
      renumberLocations();
      markInteracted();
      update();
    }
    function removeLocation(loc) {
      if (getLocationEls().length <= 1) return;
      loc.parentNode.removeChild(loc);
      renumberLocations();
      markInteracted();
      update();
    }
    root.addEventListener('click', function(e) {
      var addBtn = e.target.closest('[data-loc-add]');
      if (addBtn) { e.preventDefault(); addLocation(); return; }
      var rmBtn = e.target.closest('[data-loc-remove]');
      if (rmBtn) { e.preventDefault(); var loc = rmBtn.closest('.est-loc'); if (loc) removeLocation(loc); return; }
    });
    renumberLocations();

    refreshActiveSizes();
    update();

    /* ステッパー + / - ボタン */
    root.addEventListener('click', function(e) {
      var btn = e.target.closest('.est-stepper__btn');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var step = parseInt(btn.dataset.step || '1', 10);
      var cur = parseInt(input.value || '0', 10);
      var next = Math.max(0, Math.min(999, cur + step));
      input.value = next;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    /* モバイルで入力後、結果カードまで自動スクロール（初回だけ） */
    var scrolled = false;
    root.addEventListener('input', function() {
      if (scrolled) return;
      if (window.innerWidth >= 769) return;
      if (getSizeQty() <= 0) return;
      scrolled = true;
      var out = root.querySelector('.estimator__output');
      if (out) {
        setTimeout(function() {
          out.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 400);
      }
    });

    document.addEventListener('click', function(e) {
      var a = e.target.closest('[data-est-line-msg]');
      if (!a) return;
      var msg = a.dataset.estLineMsg || '';
      try { navigator.clipboard.writeText(msg); } catch(_) {}
      var label = a.querySelector('[data-est-line-label]');
      if (label && msg) {
        if (!label.dataset.orig) label.dataset.orig = label.textContent;
        label.textContent = '見積もりをコピー！LINEで貼り付け送信';
        setTimeout(function(){ label.textContent = label.dataset.orig; }, 2500);
      }
    });

    /* 選択中カラー表示 + 商品ページのカラー変更を反映 */
    var currentColorEl = root.querySelector('[data-est-current-color] strong');
    var estimatorEl = (root.matches && root.matches('.estimator')) ? root : root.querySelector('.estimator');
    var defaultColor = estimatorEl ? (estimatorEl.dataset.defaultColor || '') : '';
    function refreshCurrentColor(){
      if (!currentColorEl) return;
      var sel = document.querySelector('.pdetail__swatch.is-selected');
      var name = sel ? sel.dataset.optionValue : null;
      currentColorEl.textContent = name || defaultColor || '—';
    }
    refreshCurrentColor();
    setTimeout(refreshCurrentColor, 300);
    setTimeout(refreshCurrentColor, 1000);
    document.addEventListener('pdetail:variant-changed', function(){
      refreshCurrentColor();
      update();
    });

    /* カート追加ボタン */
    var cartBtn = root.querySelector('[data-est-add-cart]');
    var cartLabel = root.querySelector('[data-est-cart-label]');
    function refreshCartBtn(){
      if (!cartBtn || !cartLabel) return;
      var qty = getSizeQty();
      if (qty === 0) {
        cartBtn.disabled = true;
        cartLabel.textContent = 'カートに追加（枚数を入力してください）';
      } else {
        cartBtn.disabled = false;
        cartLabel.textContent = qty + '枚をまとめてカートに追加';
      }
    }
    root.addEventListener('input', refreshCartBtn);
    root.addEventListener('change', refreshCartBtn);
    refreshCartBtn();

    /* 見積もり結果から料金ライン（版代・プリント代・オプション）を組み立てる。
       内部「加工費」商品(¥1)を 金額分の数量 で追加し、内訳をプロパティに持たせる。 */
    function collectFeeItems(){
      var P = window.PRICING;
      var feeId = P && P.feeVariantId;
      if (!feeId || !lastRes || !lastInput) return [];
      var qty = lastRes.qty || 0;
      if (qty <= 0) return [];
      var positions = lastInput.positions;
      var silkPlates = (lastRes.silkPlates != null) ? lastRes.silkPlates : lastInput.plates;
      var locLabels = getLocationLabels(lastRes.locMethods);
      var fees = [];
      function pushFee(amount, label){
        var yenAmt = Math.round(amount || 0);
        if (yenAmt <= 0) return;
        fees.push({ id: String(feeId), quantity: yenAmt, properties: { 'プリント内訳': label } });
      }
      pushFee(lastRes.plate, '版代（' + locLabels.join('・') + '／計' + silkPlates + '版）');
      var printLabel;
      if (lastRes.method === 'dtf') {
        printLabel = 'プリント代（フルカラーDTF・' + qty + '枚×' + positions + '箇所）';
      } else if (lastRes.method === 'mix') {
        printLabel = 'プリント代（シルク＋DTF併用・' + qty + '枚・' + locLabels.join('・') + '）';
      } else {
        printLabel = 'プリント代（' + qty + '枚・' + positions + '箇所／計' + silkPlates + '版）';
      }
      pushFee(lastRes.print, printLabel);
      pushFee(lastRes.fold,  'たたみ・袋入れ（' + qty + '枚）');
      pushFee(lastRes.name,  '背番号・名入れ（' + getNameCount() + '箇所）');
      return fees;
    }

    if (cartBtn) {
      cartBtn.addEventListener('click', function(){
        var items = collectCartItems(root);
        if (!items || items.length === 0) {
          alert('サイズ別に枚数を1枚以上入力してください');
          return;
        }
        update(); // 最新の見積もりを確定してから料金ラインを生成
        items = items.concat(collectFeeItems());
        var attrs = collectCartAttributes(root);
        // 版数はシルク箇所のみ（DTF箇所は版なし）を記録
        if (lastRes && lastRes.silkPlates != null) attrs.print_plates = String(lastRes.silkPlates);
        if (cartLabel) cartLabel.textContent = '追加中...';
        cartBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function(r){ return r.json(); }).then(function(){
          var fd = new FormData();
          Object.keys(attrs).forEach(function(k){ fd.append('attributes[' + k + ']', attrs[k]); });
          return fetch('/cart/update.js', { method: 'POST', body: fd });
        }).then(function(){
          cartBtn.classList.add('is-success');
          if (cartLabel) cartLabel.textContent = '✓ 追加しました → カートへ';
          setTimeout(function(){ window.location.href = '/cart'; }, 800);
        }).catch(function(){
          if (cartLabel) cartLabel.textContent = '追加に失敗しました（もう一度）';
          cartBtn.disabled = false;
        });
      });
    }

    /* Cart Permalink 共有 */
    var shareBtn = root.querySelector('[data-est-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function(){
        update(); // 最新の見積もりを確定
        var url = buildCartPermalink(root, collectFeeItems(), lastRes);
        if (!url) return;
        try {
          navigator.clipboard.writeText(url).then(function(){
            shareBtn.classList.add('is-copied');
            var label = shareBtn.querySelector('[data-share-label]');
            if (label) label.textContent = 'コピーしました → LINEに貼り付け OK';
            setTimeout(function(){
              shareBtn.classList.remove('is-copied');
              if (label) label.textContent = 'このカート構成のURLをコピー';
            }, 3500);
          });
        } catch(_) {
          window.prompt('URLをコピーしてください', url);
        }
      });
    }
  }

  /* カート用ライン項目を組み立てる（サイズ別qty × 現在のカラー → variant_id × qty） */
  function collectCartItems(root){
    var section = (root.closest && root.closest('.estimator-section')) || root.parentElement || document;
    var mapEl = root.querySelector('[data-est-variant-map]') || section.querySelector('[data-est-variant-map]');
    if (!mapEl) return [];
    var variants;
    try { variants = JSON.parse(mapEl.textContent); } catch(_) { return []; }
    if (!Array.isArray(variants) || variants.length === 0) return [];

    var selectedColor = null;
    var colorSel = document.querySelector('.pdetail__swatch.is-selected');
    if (colorSel) selectedColor = colorSel.dataset.optionValue;

    var items = [];
    root.querySelectorAll('.est-size').forEach(function(cell){
      var label = cell.querySelector('label');
      var input = cell.querySelector('input[type="number"]');
      if (!label || !input) return;
      var sizeName = (label.textContent || '').trim();
      var qty = Math.max(0, parseInt(input.value || '0', 10));
      if (qty <= 0) return;
      var v = variants.find(function(x){
        var sm = !x.size || x.size === sizeName;
        var cm = !selectedColor || !x.color || x.color === selectedColor;
        return sm && cm;
      });
      if (v && v.id) items.push({ id: String(v.id), quantity: qty });
    });

    if (items.length === 0) {
      var totalQty = 0;
      root.querySelectorAll('.est-size input').forEach(function(el){ totalQty += Math.max(0, parseInt(el.value || '0', 10)); });
      var estRoot = (root.matches && root.matches('.estimator')) ? root : root.querySelector('.estimator');
      var defaultId = estRoot ? estRoot.dataset.defaultVariant : null;
      if (defaultId && totalQty > 0) items.push({ id: String(defaultId), quantity: totalQty });
    }
    return items;
  }

  /* カート属性を組み立て（料金内訳の記録 / Cart Permalink 両用） */
  function collectCartAttributes(root){
    var locs = Array.prototype.slice.call(root.querySelectorAll('.est-loc-list .est-loc'));
    var modeInput = root.querySelector('.est-mode input:checked');
    var foldEl = root.querySelector('.est-fold');
    var nameEl = root.querySelector('.est-name-count');
    var attrs = {};
    if (locs.length) {
      var colors = locs.map(function(loc){
        var r = loc.querySelector('input[type="radio"]:checked') || loc.querySelector('input[type="radio"]');
        return Math.max(1, parseInt((r && r.value) || '1', 10));
      });
      var plates = colors.reduce(function(a,b){ return a + b; }, 0);
      attrs.print_positions = String(locs.length);
      attrs.print_plates = String(plates);
      attrs.print_locations = colors.map(function(c, i){ return (i + 1) + '箇所目' + c + '色'; }).join(' / ');
    }
    if (modeInput) attrs.order_mode = modeInput.value;
    attrs.fold_pack = (foldEl && foldEl.checked) ? '1' : '0';
    attrs.name_print_count = (nameEl && parseInt(nameEl.value || '0', 10) > 0) ? nameEl.value : '0';
    return attrs;
  }

  /* Cart Permalink URL（コピー用）— 上記2関数の組み立てを再利用 */
  function buildCartPermalink(root, feeItems, res){
    var items = collectCartItems(root);
    if (items.length === 0) {
      alert('枚数を1枚以上入力してください');
      return null;
    }
    // 版代・プリント代・オプション等の加工費を1行にまとめて加算（カート追加と総額を一致させる）。
    // Permalinkはライン単位のproperties（プリント内訳）を持てないため、
    // 内訳の全文をカート属性(print_fee_breakdown)として渡し、カート画面で表示する。
    var attrs = collectCartAttributes(root);
    // 版数はシルク箇所のみ（DTF箇所は版なし）を記録
    if (res && res.silkPlates != null) attrs.print_plates = String(res.silkPlates);
    if (feeItems && feeItems.length) {
      var feeId = null, feeTotal = 0;
      feeItems.forEach(function(f){ feeId = f.id; feeTotal += (f.quantity || 0); });
      if (feeId && feeTotal > 0) items.push({ id: String(feeId), quantity: feeTotal });
      attrs.print_fee_breakdown = feeItems.map(function(f){
        var label = (f.properties && f.properties['プリント内訳']) || '加工費';
        return label + '：¥' + (f.quantity || 0).toLocaleString('ja-JP');
      }).join('\n');
    }
    var storeEl = root.querySelector('[data-store-base]');
    var storeBase = (storeEl && storeEl.dataset.storeBase) || location.origin;
    var pairs = items.map(function(it){ return it.id + ':' + it.quantity; });
    var params = new URLSearchParams();
    Object.keys(attrs).forEach(function(k){ if (attrs[k] !== '' && attrs[k] !== '0') params.set('attributes[' + k + ']', attrs[k]); });
    // storefront=true が無いとPermalinkは直接チェックアウトへ飛び、カートページの内訳表示を経由しない
    params.set('storefront', 'true');
    return storeBase.replace(/\/$/, '') + '/cart/' + pairs.join(',') + '?' + params.toString();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.estimator').forEach(initEstimator);
  });

  window.calcEstimate = calcEstimate;
})();
